<template>
  <div>
     <!--General Top Bar -->
     <!-- <general-top-bar :title="$t('reports.clientsWOrders')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-md-12 card text-left">
      <div class="card-header"></div>
      <div class="report-filters">
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="text" :placeholder="$t('reports.searchFilter')" class="form-control" v-model="clients.search">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left" v-if="showLocations">
          <select class="form-control" v-model="clients.location">
            <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
            <option v-for="loc in locations" :key="loc.id" :label="loc.name" :value="loc.true_id">{{loc.name}}</option>
          </select>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="number" :placeholder="$t('reports.minOrders')" class="form-control" v-model="clients.minOrder">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="number" :placeholder="$t('reports.maxOrders')" class="form-control" v-model="clients.maxOrder">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="number" :placeholder="$t('reports.minAmount')" class="form-control" v-model="clients.minAmount">
        </div>
        <div class="col-md-6">
          <p class="pull-left">
            <el-date-picker
              type="daterange"
              v-model="clients.valid"
              class="mid"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions"
            >
            </el-date-picker>

            <div class="search-button-reports form-group pull-left">
              <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="getClients(null)"><i class="ti-search"></i></div>
            </div>

            <div class="search-button-reports form-group pull-left">
              <download-excel
                :disabled="clientsTableData.length == 0"
                class   = "btn btn-icon mar-rt-40 btn-xls"
                :fetch   = "clientsExportData"
                :fields = "jsonFields"
                :name    = "export_name"
                :before-generate = "startDownload"
                :before-finish   = "finishDownload">
                {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
              </download-excel>
            </div>
          </p>
        </div>
        <!-- <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range"> -->
      </div>
      <!-- <div class=""> -->

      <!-- </div> -->
      <div class="card-content total-pagination pad-15">
        <data-tables-server
          class=""
          @query-change="paginationChanged"
          v-loading="loading"
          :data="clientsTableData"
          :search-def="{ show: false }"
          :total="totalClients"
          :pagination-props="paginationProps"
          :table-props="tableOptions"
          @row-click="goToRecordCustomer"
          style="width: 100%;"
        >
          <el-table-column :min-width="80" sortable="custom" prop="location_name" :label="$t('reports.location')"></el-table-column>
          <el-table-column :min-width="80" sortable="custom" prop="name" :label="$t('reports.name')">
            <template slot-scope="props">
              {{ props.row.firstname }} {{ props.row.lastname }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="120"
            sortable="custom"
            prop="email"
            :label="$t('reports.email')"
          ></el-table-column>
          <el-table-column
            :min-width="60"
            sortable="custom"
            prop="phone"
            :label="$t('reports.phone')"
          ></el-table-column>
          <el-table-column
            :min-width="60"
            sortable="custom"
            prop="gender"
            :label="$t('reports.gender')"
          ></el-table-column>
          <el-table-column
            :min-width="40"
            sortable="custom"
            prop="age"
            :label="$t('reports.age')"
          ></el-table-column>
          <el-table-column
            :min-width="80"
            sortable="custom"
            prop="sales"
            :label="$t('reports.totalAmount')"
          >
            <template slot-scope="props">
              {{ formatMoneyAmount(props.row.sales) }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="80"
            sortable="custom"
            prop="orders_count"
            :label="$t('reports.ordersNumber')"
          >
            <template slot-scope="props">
              {{ props.row.orders_count }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="60"
            prop="label"
            :label="$t('reports.label')"
          >
            <template slot-scope="props">
              <b v-html="getUserLabel(labels, props.row.last_sales, props.row.last_orders, labelingPrimaryOption)"></b>
            </template>
          </el-table-column>
          <el-table-column
            v-if="donation_points_enabled"
            :min-width="80"
            prop="donation_points"
            :label="$t('reports.donation_points')"
          >
            <template slot-scope="props">
              <b v-if="props.row.hasOwnProperty('donation_points')">{{props.row.donation_points}}</b>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isClients: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.verifyUserLocations()
  },
  watch: {
    isClients () {
      if (this.isClients) {
        let firstQuery = {
          sort: {
            prop: 'name',
            order: 'asc'
          },
          page: 1,
          pageSize: 20
        }
        this.getClients(firstQuery)
      }
    }
  },
  data () {
    return {
      loading: false,
      donation_points_enabled: false,
      jsonFields: {
        [this.$t('reports.name')]: 'firstname',
        [this.$t('reports.email')]: 'email',
        [this.$t('reports.phone')]: 'phone',
        [this.$t('reports.gender')]: 'gender',
        [this.$t('reports.age')]: 'age',
        [this.$t('reports.donation_points')]: 'donation_points',
        [this.$t('reports.totalAmount')]: 'sales',
        [this.$t('reports.ordersNumber')]: 'orders_count'
      },
      export_name: 'Export Clienti - ',
      clients: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD')
        ],
        minOrder: null,
        maxOrder: null,
        minAmount: null,
        search: null,
        location: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        // pageSizes: [5, 10, 15],
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(24, 'months')
        }
      },
      pickerNames: ['date_from', 'date_to']
    }
  },
  methods: {
    async clientsExportData () {
      let resp = []
      if (this.clients) {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.clients.valid[0],
          end_date: this.clients.valid[1],
          min_orders: this.clients.minOrder,
          max_orders: this.clients.maxOrder,
          min_ammount: this.clients.minAmount,
          filter: this.clients.search,
          location_id: this.clients.location
        }

        let $dd = {}
        const sortOptions = {
          field: this.sortBy,
          order: this.sortOrder
        }
        data = {
          ...data,
          ...sortOptions
        }


        let ced = []
        let clientsData = []
        resp = await new Promise((resolve, reject) => {
          const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
          this.apiRequest('/reports/clients' + ver + '?page=' + 1 + '&pageSize=' + 50000, 'GET', data, response => {
            clientsData = response.data.clients.data
            if (clientsData) {
              for (const customer of clientsData) {
                $dd = {
                  'firstname': customer.firstname,
                  'email': customer.email,
                  'phone': customer.phone,
                  'gender': customer.gender,
                  'birthdate': customer.birthdate,
                  'age': customer.age,
                  'orders_count': customer.orders_count,
                  'sales': this.formatMoneyAmount(customer.sales, '')
                }
                if (customer.donation_points) {
                  $dd['donation_points'] = customer.donation_points
                }
                ced.push($dd)
              }
            }
            resolve(ced)
          })
        })
        return resp
      }
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getClients(query)
      if (query.type === 'size') this.getClients(query)
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc'
        } else {
          this.sortBy = 'name'
          this.sortOrder = 'asc'
        }
        this.getClients(query)
      }
    },
    getClients (query) {
      if (!this.isClients) {
        return
      }
      this.export_name = this.export_name + this.clients.valid[0] + ' - ' + this.clients.valid[1]
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        min_orders: this.clients.minOrder,
        max_orders: this.clients.maxOrder,
        min_ammount: this.clients.minAmount,
        filter: this.clients.search,
        location_id: this.clients.location
      }

      let sortColumn = ''
      let sortType = ''
      // let $dd = {}
      if (query) {
        sortColumn = query.sort.prop
        sortType = query.sort.order === 'descending' ? 'desc' : 'asc'
      } else {
        sortColumn = this.sortBy
        sortType = this.sortOrder
      }

      const sortOptions = {
        field: sortColumn,
        order: sortType
      }
      data = {
        ...data,
        ...sortOptions
      }

      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
      this.apiRequest('/reports/clients' + ver + '?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
        if (response.status === true) {
          this.donation_points_enabled = response.data.use_donation_points
          this.clientsTableData = response.data.clients.data
          this.totalClients = response.data.clients.total
          this.labels = response.data.labels
          this.labelingPrimaryOption = response.data.fidelities_labels_primary_option

          // this.$refs.refClientsChart.initChart()
          // this.clientsExportData = []
          if (this.clientsTableData) {
            for (const customer of this.clientsTableData) {
              // $dd = {
              //   'firstname': customer.firstname,
              //   'email': customer.email,
              //   'phone': customer.phone,
              //   'gender': customer.gender,
              //   'birthdate': customer.birthdate,
              //   'age': customer.age,
              //   'orders_count': customer.orders_count,
              //   'sales': this.formatMoneyAmount(customer.sales, '')
              // }
              // if (customer.donation_points) {
              //   $dd['donation_points'] = customer.donation_points
              // }
              // this.clientsExportData.push($dd)
              if (customer.lastname) {
                customer['firstname'] = customer.firstname + ' ' + customer.lastname
              }
            }
          }
        }
        this.$nextTick(function () {
          this.loading = false
        })
      })
    },
    goToRecordCustomer (row, event, column) {
      window.open(`/#/reports/customer/${row.id}`)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details
      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }
      if (this.locations.length > 1) {
        this.showLocations = true
      }
      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.clients.location = filterCookie[0]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Clients.vue